import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import saglikImage from '../assets/saglik.avif';
import isyeriImage from '../assets/isyeri.avif';
import konutImage from '../assets/konut.avif';
import trafikImage from '../assets/trafik.avif';

const Home = () => {
  const services = [
    {
      id: 1,
      title: 'Sağlık Sigortası',
      shortDescription: 'Sağlığınız her zaman güvende.',
      image: saglikImage
    },
    {
      id: 2,
      title: 'İşyeri Sigortası',
      shortDescription: 'İşiniz bizimle güvende.',
      image: isyeriImage
    },
    {
      id: 3,
      title: 'Konut Sigortası',
      shortDescription: 'Eviniz için tam koruma.',
      image: konutImage
    },
    {
      id: 4,
      title: 'Trafik Sigortası',
      shortDescription: 'Yolda içiniz rahat olsun.',
      image: trafikImage
    },
    {
      id: 5,
      title: 'Sorumluluk Sigortası',
      shortDescription: 'Risklere karşı güçlü koruma.',
      image: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 6,
      title: 'Seyahat-Sağlık Sigortası',
      shortDescription: 'Seyahatinizde güvende olun.',
      image: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    }
  ];

  return (
    <div className="home">
      <section className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>
            ESR GROUP
            <br />
            Sigorta ve Aracılık Hizmetleri
          </h1>
          <p className="hero-slogan">Güvenilir sigorta çözümleri için yanınızdayız.</p>
          <div className="hero-buttons">
            <Link to="/hizmetler" className="btn btn-primary">Hizmetlerimiz</Link>
            <Link to="/iletisim" className="btn btn-secondary">İletişim</Link>
          </div>
        </div>
      </section>

      <section className="services-preview">
        <div className="container">
          <h2>Hizmetlerimiz</h2>
          <div className="services-grid">
            {services.map((service, index) => {
              const serviceIds = ['saglik', 'isyeri', 'konut', 'trafik', 'sorumluluk', 'seyahat'];
              return (
                <Link
                  key={service.id}
                  to={`/hizmetler?service=${serviceIds[index]}`}
                  className="service-card"
                >
                  <div className="service-icon" style={{ backgroundImage: `url(${service.image})` }}></div>
                  <h3>{service.title}</h3>
                  <p>{service.shortDescription}</p>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      <section className="why-us">
        <div className="container">
          <h2>Neden ESR Group?</h2>
          <div className="features-grid">
            <div className="feature">
              <div className="feature-icon">✓</div>
              <h3>Güvenilir</h3>
              <p>Yılların deneyimi ile güvenilir hizmet</p>
            </div>
            <div className="feature">
              <div className="feature-icon">⚡</div>
              <h3>Hızlı</h3>
              <p>Hızlı ve kolay sigorta işlemleri</p>
            </div>
            <div className="feature">
              <div className="feature-icon">💼</div>
              <h3>Rekabetçi Fiyatlandırma</h3>
              <p>Piyasadaki en rekabetçi fiyatlarla kaliteli sigorta çözümleri</p>
            </div>
            <div className="feature">
              <div className="feature-icon">📞</div>
              <h3>7/24 Destek</h3>
              <p>Her zaman yanınızdayız</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;

